import { Logger } from '@frontend/logger';
import { useEffect, useRef, useState } from 'react';

import { OnboardScannerProps } from './onboard-scanner.component';

interface ViewProps {
    value: string;
}

const useOnboardScanner = (props: OnboardScannerProps): ViewProps => {
    const [value, setValue] = useState<string>('');
    const bufferRef = useRef<string>('');

    useEffect(() => {
        const handleEvent = (event: any) => {
            Logger.log('Onboard scanner key pressed event triggered:', event.key);
            if (event.key.length > 1) return;
            bufferRef.current += event.key;
            setValue(bufferRef.current);

            setTimeout(() => {
                bufferRef.current = '';
            }, 1000);
        };

        document.addEventListener('keypress', handleEvent);
        return () => {
            document.removeEventListener('keypress', handleEvent);
        };
    }, []);

    useEffect(() => {
        if (value === '') return;
        const timeout = setTimeout(() => {
            props.callback && props.callback(value);
            setValue('');
        }, 500);
        return () => clearTimeout(timeout);
    }, [value]);

    return { value };
};

export default useOnboardScanner;
